import { createReducer, on } from '@ngrx/store';

import { InfoMessagesActions } from './actions';
import { defaultInfoMessagesState } from './state';

export const infoMessagesReducer = createReducer(
    defaultInfoMessagesState,
    on(InfoMessagesActions.toggle, (state, action) => {
        if (state.currentMessageId === action.messageId) {
            return {
                currentMessageId: null,
            };
        }

        return {
            currentMessageId: action.messageId,
        };
    }),
    on(InfoMessagesActions.closeById, (state, action) => {
        if (state.currentMessageId === action.messageId) {
            return {
                currentMessageId: null,
            };
        }

        return state;
    }),
);
